// STUB — FTMS Stair Climber Data characteristic (0x2AD0). Spec §4.12.
//
// Phase 2: 16-bit flags. Bit 0 inverted (More Data). Field order: Floors
// Climbed (uint16) when bit 0 clear, then Step Per Minute + Avg, Positive
// Elevation Gain, Stride Count, Expended Energy, HR, MET, Elapsed Time,
// Remaining Time.

import type { StairClimberMetrics } from "../types";

export function parseStairClimberData(_view: DataView): StairClimberMetrics {
  return {
    type: "stair_climber",
    power_watts: null,
    heart_rate_bpm: null,
    elapsed_time_s: null,
    remaining_time_s: null,
    step_rate_spm: null,
    floors_climbed: null,
  };
}
